import LocalStorageConstant from "../../constants/localStorage.constant";

const getLocalRefreshToken = () => {
  return localStorage.getItem(LocalStorageConstant.refreshToken);
};

const getLocalAccessToken = () => {
  return localStorage.getItem(LocalStorageConstant.accessToken);
};

const addOrUpdateLocalAccessToken = (token: string) => {
  localStorage.setItem(LocalStorageConstant.accessToken, token);
};

const addOrUpdateLocalRefreshToken = (token: string) => {
  localStorage.setItem(LocalStorageConstant.refreshToken, token);
};

const removeUser = () => {
  localStorage.removeItem(LocalStorageConstant.user);
};

const TokenService = {
  removeUser,
  getLocalAccessToken,
  getLocalRefreshToken,
  addOrUpdateLocalAccessToken,
  addOrUpdateLocalRefreshToken,
};

export default TokenService;
